import React from 'react';
import './Contact.css';
import Navbar from './Navbar';
import heroImg from '../assets/hero6.webp';
import Footer from './Footer';

const Contact = () => {
    return (
        <div className="contact-page">
            <Navbar />

            <section className="contact-hero" style={{ backgroundImage: `url(${heroImg})` }}>
                <div className="contact-hero-overlay"></div>
                <div className="contact-hero-content">
                    <h1 className="contact-heading">Nehmen Sie Kontakt auf</h1>
                    <p className="contact-subtitle">Wir sind für alle Ihre Fragen gerne da</p>
                </div>
            </section>

            <section className="contact-main">
                <div className="contact-container">
                    <div className="contact-info">
                        <h2 className="contact-info-title">Kontaktdaten</h2>

                        <div className="info-card">
                            <div className="info-icon"><svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1-9.4 0-17-7.6-17-17 0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.6.1.3 0 .7-.2 1L6.6 10.8z"/></svg></div>
                            <div className="info-text"><span className="info-label">Telefon</span><a href="tel:+43123456789" className="info-value">+43 123 456 789</a></div>
                        </div>

                        <div className="info-card">
                            <div className="info-icon"><svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/></svg></div>
                            <div className="info-text"><span className="info-label">E-Mail</span><a href="mailto:info@luckygarden.at" className="info-value">info@lucky-garden.at</a></div>
                        </div>

                        <div className="info-card">
                            <div className="info-icon"><svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/></svg></div>
                            <div className="info-text"><span className="info-label">Adresse</span><span className="info-value">Straubinger Straße 22<br/>4600 Wels, Österreich</span></div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </div>
    );
};

export default Contact;
